export interface BooleanConfigurations {
    [key: string]: boolean;
}

export interface JSONConfiguration {
    [key: string]: any;
}

// User defined values based on active configurations
export enum ChannelName {
    MIJN_KLANT = 'mijn-klant',
    MIJN_KANTOOR = 'mijn-kantoor',
    MIJN_BETALEN = 'mijn-betalen',
    MIJN_HYPOTHEKEN = 'mijn-hypotheken',
    MIJN_KLANT_TOEGANG_DERDEN = 'mijn-klant-toegang-derden',
    PEGA = 'pega'
}
